export default __webpack_public_path__ + "static/media/react.6ab7e2e9.png";